<!--
<button type="button" *ngIf="attributeFilter.value !== null && attributeFilter.value !== undefined" (click)="removeButton()"
        class="btn btn-outline-secondary ml-2">
    <span [innerHTML]="attributeFilter.htmlButtonText()" class="mr-1"></span>
    <span class="text-danger font-weight-bold">&times;</span>
</button>
-->
<div class="chip mr-2" *ngIf="attributeFilter.value !== null && attributeFilter.value !== undefined">
  <span [innerHTML]="attributeFilter.htmlButtonText()"></span>
  <mdb-icon fas icon="times" class="text-danger close" (click)="removeButton()"></mdb-icon>
</div>
